export const downArrow = (color = '#403F42') =>
	`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.1547 14.4662C12.845 14.7643 12.355 14.7643 12.0453 14.4662L9.35392 11.8765C8.83499 11.3771 9.18846 10.5 9.90862 10.5H15.2914C16.0115 10.5 16.365 11.3771 15.8461 11.8765L13.1547 14.4662Z" 
        fill="${color}"/>
    </svg>`;
